<div class="bbb-subheader" id="bbb-subheader" *ngIf="currentURL=='bbb-profile' || currentURL == 'list-influencers' || currentURL=='notifications' ||  currentURL == 'inbox' || currentURL=='knot-profile' || currentURL=='joy-profile' || currentURL=='zola-profile' || currentURL=='thnks-profile' || currentURL=='sendoso-profile'|| currentURL=='postal-profile'  || currentURL=='add-experiences' || currentURL=='add-experience-by-city' || currentURL =='gift-tracker' || currentURL =='news-feeds' || currentURL =='our-friends' || currentURL =='refer-friends' || currentURL =='find-vebo-couples' || currentURL =='settings' || currentURL == 'settings?claim=voucher' || currentURL1=='add-experience-by-city' || currentURL1=='add-experiences'">
    <div class="container">
        <nav class="navbar navbar-expand-lg">
            <!-- <div class="wedding-couple-menu-toggle d-lg-none" id="bbb-menu-toggle">
          Menu
          <i class="fas fa-long-arrow-down"></i>
        </div> -->
            <div class="navbar-collapse" id="bbbNav" hidden>
                <ul class="navbar-nav ml-auto">

                    <li *ngIf="authUser && (authUser?.role_id == 5 || authUser?.role_id == 9)" class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
                        <a class="nav-link" [routerLink]="['/bbb-profile']">PROFILE</a>
                    </li>
                    <li *ngIf="authUser && authUser?.role_id == 10" class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
                        <a class="nav-link" [routerLink]="['/knot-profile']">PROFILE</a>
                    </li>
                    <li *ngIf="authUser && authUser?.role_id == 11" class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
                        <a class="nav-link" [routerLink]="['/joy-profile']">PROFILE</a>
                    </li>
                    <li *ngIf="authUser && authUser?.role_id == 12" class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
                        <a class="nav-link" [routerLink]="['/zola-profile']">PROFILE</a>
                    </li>
                    <li *ngIf="authUser && authUser?.role_id == 17" class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
                        <a class="nav-link" [routerLink]="['/postal-profile']">PROFILE</a>
                    </li>

                    <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}" [ngClass]="{'activeLinkFriends':(currentURL == 'add-experiences' || currentURL == 'add-experience-by-city' || currentURL == 'region' || currentURL1=='add-experience-by-city' || currentURL1=='add-experiences')}">
                        <a class="nav-link" [routerLink]="['/add-experiences']">Add EXPERIENCES</a>
                    </li>

                    <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
                        <a class="nav-link" [routerLink]="['/gift-tracker']"> GIFT TRACKER</a>
                    </li>

                    <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
                        <a class="nav-link" [routerLink]="['/inbox']">INBOX</a>
                    </li>

                    <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}" [ngClass]="{'activeLinkFriends':(currentURL == 'news-feeds' || currentURL == 'our-friends' || currentURL == 'refer-friends' || currentURL == 'find-vebo-couples')}">
                        <a class="nav-link" [routerLink]="['/our-friends']"> CONNECT
                            <span class="blue_menu_notification_counter" *ngIf="total_notification_counter>0">{{total_notification_counter}}</span>
                            <div class="friend_counter">
                            <img src="assets/images/icon-friend.png">
                            <span class="red_menu_friend_notification_counter" *ngIf="total_friend_counter>0">{{total_friend_counter}}</span>
                            </div>
                        </a>
                    </li>

                    <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
                        <a class="nav-link" [routerLink]="['/ticket-category']"> SPURTicketing</a>
                    </li>

                    <!-- <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
                        <a class="nav-link" [routerLink]="['/notifications']">Notifications</a>
                    </li> -->

                    <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}" [ngClass]="{'activeLinkFriends':(currentURL == 'settings' || currentURL == 'settings?claim=voucher')}">
                        <a class="nav-link" [routerLink]="['/settings']">Settings</a>
                    </li>

                </ul>
            </div>
        </nav>
    </div>
</div>

<div class="cartpopup-wrap" *ngIf="show_card_details">
    <div class="cartpopup-overly"></div>

    <div class="cartpopup_box">
        <div class="cartpopup_head">
            <span class="cart_counter">
            <span class="cart-icon"></span>
            <span class="cart_count_popup">{{cart_details.length}}</span>
            </span>
            <span class="odr-title">YOUR ORDER</span>
            <a href="javascript:void(0);" class="cart_pop_close" (click)="show_card_details = !show_card_details">
                <i class="fa fa-times remove"></i>
            </a>
        </div>

        <div class="cartpopup_content">
            <!-- Empty Box START -->
            <div class="cartpopup_empty" *ngIf="cart_details && cart_details.length == 0">
                <p>Your cart is currently empty.</p>
                <a href="javascript:void(0);" class="btn" (click)="show_card_details = !show_card_details">← Return To Shop</a>
            </div>
            <!-- Empty Box END -->

            <div class="cartpopup_content_inner" *ngIf="cart_details && cart_details.length > 0">
                <div class="cartpopup_product" *ngFor="let cart of cart_details">
                    <div class="cartpopup_removecart">
                        <a href="javascript:void(0);" title="Remove this item" (click)="removeItem(cart.product_id)">×</a>
                    </div>
                    <div class="cartpopup_proname">
                        <a href="javascript:void(0)">{{cart.title}}</a>
                    </div>
                    <!-- <div class="cartpopup_vrcname">
                <span>Name on Voucher:</span>
                ashu23223 sdf estef tets sefdsf
              </div> -->
                    <div class="cartpopup_proqty">
                        Quantity: {{cart.qty}}
                    </div>
                    <div class="cartpopup_vrcname">
                        <span>Option:</span> Buy For Yourself
                    </div>
                    <div class="row no-gutters mt-2 align-items-end">
                        <div class="col">
                            <div class="cartpopup_wall">
                                <img src="{{cart.image}}" alt="" />
                            </div>
                        </div>
                        <div class="col">
                            <div class="cartpopup_proprice">
                                ${{cart.line_total}}
                            </div>
                        </div>
                    </div>
                </div>



                <!-- <div class="cartpopup_product">
              <div class="cartpopup_removecart">
                <a href="javascript:void(0);" title="Remove this item">×</a>
              </div>
              <div class="cartpopup_proname">
                <a href="javascript:void(0)">Group Fly Fishing</a>
              </div>
              <div class="cartpopup_vrcname">
                <span>Name on Voucher:</span>
                ashu23223 sdf estef tets sefdsf
              </div>
              <div class="cartpopup_proqty">
                Quantity: 1
              </div>
              <div class="cartpopup_vrcname">
                <span>Option:</span>
                Buy For Yourself
              </div>
              <div class="row no-gutters mt-2 align-items-end">
                <div class="col">
                  <div class="cartpopup_wall">
                    <img src="assets/images/home_owl_1.jpg" alt="" />
                  </div>
                </div>
                <div class="col">
                  <div class="cartpopup_proprice">
                    $525
                  </div>
                </div>
              </div>
            </div> -->
            </div>

            <div class="cartpopup_content_footer" *ngIf="cart_details && cart_details.length > 0">

                <div class="cartpopup_total">

                    <div class="form-row">
                        <div class="col">
                            <strong>Sales Tax</strong>
                        </div>
                        <div class="col">
                            <div class="cartpopup-amount">${{total_sales_tax}}</div>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="col">
                            <strong>Total: </strong>
                        </div>
                        <div class="col">
                            <div class="cartpopup-amount">${{total_cart_amount}}</div>
                        </div>
                    </div>

                </div>
                <div class="cartpopup_continueshop_btn">
                    <a href="javascript:void(0)" (click)="show_card_details = !show_card_details">Continue Shopping</a>
                </div>
                <div class="cartpopup_checkout_btn">
                    <a href="javascript:void(0)" (click)="checkout()">CHECKOUT</a>
                </div>

            </div>
        </div>
    </div>
</div>

<div *ngIf="currentURL=='ticket-category' || currentURL=='ticket-evolution-category' || currentURL=='our-tickets'">
    <app-veboticketing-subheader></app-veboticketing-subheader>
</div>
